<template lang="html">
  <nav
    class="sub-navigation"
  >
    <ul class="sub-navigation__list">
      <li
        v-for="item in sortedItems"
        :key="item.id"
        class="sub-navigation__item"
      >
        <AppLink
          :is-link="item.targetPage && !!item.targetPage.url"
          :to="item.targetPage && item.targetPage.url"
          class="sub-navigation__text"
        >
          <span class="sub-navigation__link">{{ item.readableName }}</span>
        </AppLink>
      </li>
    </ul>
  </nav>
</template>

<script>
import { sortBy } from 'lodash'
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    AppLink
  },
  props: {
    items: {
      type: Array,
      default: () => ''
    }
  },
  computed: {
    sortedItems () {
      return sortBy(this.items, 'sort_key')
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';
  .sub-navigation__item {
    transition: transform 200ms ease-in-out, opacity 200ms ease-in-out;

    &:not(:last-child) {
      border-bottom: 1px solid gray(3);
    }
  }

  @for $i from 0 through 10 {
    .sub-navigation__item:nth-child(#{$i}n) {
      transition-delay: #{$i * 50}ms;
    }
  }

  .sub-navigation__text {
    padding: scale(4) scale(6) scale(3) scale(6);
    display: block;
    white-space: nowrap;

    &:hover, &:active {
      .sub-navigation__link {
        border-bottom: 1px solid gray(1);
      }
    }
  }

</style>
